import FullLoading from "../../../../../../components/FullLoading";
import DocumentItem from "../../../../../documents/components/DocumentItem";
import useDocumentsByUserOrganizationId from "../../hooks/useDocumentsByUserOrganizationId";
import useOrganizationSharings from "../../../../../../hooks/useOrganizationSharings";
import { DocumentType } from "../../../../../../__generated__/graphql";

interface CollaboratorDocumentsProps {
  userOrganizationId?: string;
  filterByDocumentType?: DocumentType[];
}

export default function CollaboratorDocuments({
  userOrganizationId,
  filterByDocumentType,
}: CollaboratorDocumentsProps) {
  const { data: documents, loading: documentsLoading } =
    useDocumentsByUserOrganizationId(userOrganizationId);
  const { loading: organizationSharingsLoading, externalUserOrganizations } =
    useOrganizationSharings();

  const userOrganization = externalUserOrganizations?.find(
    (userOrganization) => userOrganization?.id === userOrganizationId
  );

  if (documentsLoading || organizationSharingsLoading) return <FullLoading />;

  const docs = documents?.documentsByUserOrganizationId
    ?.filter((document) => document !== null)
    .filter((document) => {
      if (filterByDocumentType) {
        return filterByDocumentType.includes(document.type);
      }
      return true;
    })
    .map((document) => document);

  if (!userOrganization) {
    return <div>Pas d'informations trouvées</div>;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {docs?.map((document) => (
          <DocumentItem key={document.id} document={document} />
        ))}
      </div>
    </div>
  );
}
